import React from 'react';
import './FileExplorer.css';

function FileExplorer() {
	return <div className="file-explorer-page">Test</div>;
}

export default FileExplorer;
